import { generateMdiIcon } from '@helios/ag-grid-config'

export enum ReconRunStatus {
  'READY' = 'ready',
  'READY_ETLS' = 'readyEtls',
  'RUNNING' = 'running',
  'RUNNING_ETLS' = 'runningEtls',
  'FINISHED' = 'finished',
  'FINISHED_ETLS' = 'finishedEtls',
  'FAILED' = 'failed',
  'FAILED_ETLS' = 'failedEtls',
  'INDETERMINATE' = 'indeterminate',
  'INDETERMINATE_ETLS' = 'indeterminateEtls',
  'INVALID' = 'invalid',
  'INVALID_ETLS' = 'invalidEtls',
}

export const perseusRunStatusTypes: Record<ReconRunStatus, string> = {
  [ReconRunStatus.READY]: generateMdiIcon('mdi-timer-sand'),
  [ReconRunStatus.READY_ETLS]: `${generateMdiIcon(
    'mdi-timer-sand',
  )}${generateMdiIcon('mdi-database')}`,
  [ReconRunStatus.RUNNING]: generateMdiIcon('mdi-play'),
  [ReconRunStatus.RUNNING_ETLS]: `${generateMdiIcon(
    'mdi-play',
  )}${generateMdiIcon('mdi-database')}`,
  [ReconRunStatus.FINISHED]: generateMdiIcon('mdi-check-circle', [
    'text-success',
  ]),
  [ReconRunStatus.FINISHED_ETLS]: `${generateMdiIcon('mdi-check-circle', [
    'text-success',
  ])}${generateMdiIcon('mdi-database')}`,
  [ReconRunStatus.FAILED]: generateMdiIcon('mdi-alert-circle', ['text-danger']),
  [ReconRunStatus.FAILED_ETLS]: generateMdiIcon('mdi-alert-circle', [
    'text-danger',
  ]),
  [ReconRunStatus.INDETERMINATE]: generateMdiIcon('mdi-help-box', [
    'text-danger',
  ]),
  [ReconRunStatus.INDETERMINATE_ETLS]: generateMdiIcon('mdi-help-box', [
    'text-danger',
  ]),
  [ReconRunStatus.INVALID]: generateMdiIcon('mdi-cancel', ['text-danger']),
  [ReconRunStatus.INVALID_ETLS]: generateMdiIcon('mdi-cancel', ['text-danger']),
}

export const humanReadableStatusTypes: Record<ReconRunStatus, string> = {
  [ReconRunStatus['READY']]: 'Ready',
  [ReconRunStatus['READY_ETLS']]: 'Ready ETLs',
  [ReconRunStatus['RUNNING']]: 'Running',
  [ReconRunStatus['RUNNING_ETLS']]: 'Running ETLs',
  [ReconRunStatus['FINISHED']]: 'Finished',
  [ReconRunStatus['FINISHED_ETLS']]: 'Finished ETLs',
  [ReconRunStatus['FAILED']]: 'Failed',
  [ReconRunStatus['FAILED_ETLS']]: 'Failed ETLs',
  [ReconRunStatus['INDETERMINATE']]: 'Indeterminate',
  [ReconRunStatus['INDETERMINATE_ETLS']]: 'Indeterminate ETLs',
  [ReconRunStatus['INVALID']]: 'Invalid',
  [ReconRunStatus['INVALID_ETLS']]: 'Invalid ETLs',
}
